import { memo, useEffect, useMemo } from 'react';

import ErrorBoundary from '../ErrorBoundary';
import GamingHub from '../GamingHub';
import { useScript } from '../hooks/useScript';

import type { Enum } from '@shared-types/enum.types';

declare global {
  interface Window {
    ecTouchPlatform: any;
  }
}

export const GamingCardType = {
  'group-predictor': 'group-predictor',
  'match-predictor': 'match-predictor',
  'pick-your-team': 'ec-touch-global',
} as const;
export type GamingCardType = Enum<typeof GamingCardType>;
export type GamingCardTypes = keyof typeof GamingCardType;

export type GamingCardProps = { type: GamingCardTypes; component: string; [key: string]: any };

const Gaming = (props: GamingCardProps) => {
  const { type, component } = props;
  useScript(component, `script-game-card-${type}`);

  useEffect(() => {
    if (type === 'pick-your-team') {
      window.ecTouchPlatform ??= function (data) {
        window.ecTouchPlatform.init ??= [];
        window.ecTouchPlatform.init.push(data);
      };
      typeof window.ecTouchPlatform === 'function' &&
        window.ecTouchPlatform({
          clientID: props?.gamingClientId ?? 'bRUVL8o0KiMIDRBKojxECtTWp',
        });
    }
  }, [props, type]);

  const Tag: any = useMemo(() => GamingCardType[type], [type]);

  const tagProps: { groupId?: string; matchId?: string; id?: string } = useMemo(() => {
    const typePropsMap = {
      'group-predictor': { groupId: props?.groupId },
      'match-predictor': { matchId: props?.matchId },
      'pick-your-team': { id: props?.campaignId },
    } as const;

    return typePropsMap[type];
  }, [props, type]);

  return (
    <ErrorBoundary>
      <GamingHub options={props} passiveMode />
      {Tag && <Tag {...tagProps} />}
    </ErrorBoundary>
  );
};

export default memo(Gaming);
